export default __webpack_public_path__ + "static/media/bk-feature-4.f89a709f.png";